import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import { usePermissions } from '@/hooks/usePermissions';

interface DiagnosticOutcomeBadgeProps {
  needsDiagnosticOutcome: boolean;
  onClick?: () => void;
}

/**
 * Visual indicator badge shown on tickets that require diagnostic outcome recording.
 * Only visible to SERVICE_WRITER and MANAGER roles.
 * Clicking the badge REPORTS what competency evidence is still owed. It no
 * longer opens an authoring surface: the outcome is the performing
 * technician's assertion, made from their own timer.
 */
export const DiagnosticOutcomeBadge = ({
  needsDiagnosticOutcome,
  onClick,
}: DiagnosticOutcomeBadgeProps) => {
  const { canRecordDiagnosticOutcome } = usePermissions();

  // Only show for writers/managers and when the flag is true
  if (!canRecordDiagnosticOutcome || !needsDiagnosticOutcome) {
    return null;
  }

  return (
    <Badge
      variant="outline"
      className="bg-amber-500/10 text-amber-600 border-amber-500/30 hover:bg-amber-500/20 cursor-pointer flex items-center gap-1 text-xs"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <AlertTriangle className="h-3 w-3" />
      Diagnostic Outcome Required
    </Badge>
  );
};
